var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"type":_vm.type,"outlined":_vm.buttonOutlined,"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }